// Auto-extracted from SellerProducts.jsx
import { useState, useEffect, useMemo } from "react";
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Btn } from "../../components/Btn";
import { Eyebrow } from "../../components/Eyebrow";
import { Icon } from "../../components/Icon";
import { Skeleton } from "../../components/Skeleton";
import { EmptyState } from "../../components/EmptyState";
import { supabase } from "../../lib/supabase";
import { fmtK } from "../../lib/money";
import { gradientForId } from "../../lib/gradients";
import { resolveImage } from "../../lib/images";
import { useCategories } from "../../hooks/useCategories";
import { STATUS_TABS, PRESET_VARIANT_TYPES, DELIVERY_METHODS, MAX_PHOTOS } from "./constants";

export function ProductRow({ product, selected, onOpen }) {
  const img = resolveImage(product.images, "thumb");
  const low = product.stock_qty > 0 && product.stock_qty <= (product.low_stock_threshold ?? 5);
  const out = product.stock_qty === 0;
  const statusTone =
    product.status === "active"
      ? { bg: C.greenBg, fg: C.greenDk, label: "Active" }
      : product.status === "paused"
      ? { bg: C.amberBg, fg: C.amberDk, label: "Paused" }
      : { bg: C.cream, fg: C.muted, label: product.status };

  return (
    <div
      onClick={() => onOpen(product)}
      style={{
        display: "grid",
        gridTemplateColumns: "48px 2fr 1fr 1fr 1fr 0.8fr",
        gap: 12,
        padding: "12px 16px",
        alignItems: "center",
        cursor: "pointer",
        background: selected ? C.cream : "transparent",
        borderBottom: `1px solid ${C.cream}`,
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 10,
          overflow: "hidden",
          background: img ? C.cream : gradientForId(product.id),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {img ? (
          <img src={img} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
          <Icon name="tag" size={16} color={C.dust} />
        )}
      </div>
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontSize: 13,
            fontWeight: 800,
            color: C.charcoal,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {product.title}
        </div>
        <div style={{ fontSize: 11, color: C.muted }}>{product.category?.name || "—"}</div>
      </div>
      <div style={{ fontSize: 13, fontWeight: 800, color: C.charcoal }}>{fmtK(product.price)}</div>
      <div style={{ fontSize: 12.5, fontWeight: 700, color: out ? C.red : low ? C.amberDk : C.charcoal }}>
        {product.stock_qty} {low && !out ? "(low)" : ""}
      </div>
      <div style={{ fontSize: 12.5, color: C.charcoal }}>{product.total_sold || 0}</div>
      <div>
        <span
          style={{
            fontSize: 10.5,
            fontWeight: 800,
            padding: "3px 8px",
            borderRadius: 8,
            background: statusTone.bg,
            color: statusTone.fg,
            textTransform: "uppercase",
            letterSpacing: 1,
          }}
        >
          {statusTone.label}
        </span>
      </div>
    </div>
  );
}

// Unified create/edit form. mode="create" -> insert into products + update
// seller.product_count. mode="edit" -> update existing row.
